module.exports = __webpack_public_path__ + "img/Pattern03.f429410a.png";